module.exports = __webpack_public_path__ + "static/media/aahar1.f28d1c7b.png";